import React from "react";

const Categories = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.41667 8.16663L8 0.666626L12.5833 8.16663H3.41667ZM12.5833 17.3333C11.5417 17.3333 10.6562 16.9687 9.92708 16.2395C9.19792 15.5104 8.83333 14.625 8.83333 13.5833C8.83333 12.5416 9.19792 11.6562 9.92708 10.927C10.6562 10.1979 11.5417 9.83329 12.5833 9.83329C13.625 9.83329 14.5104 10.1979 15.2396 10.927C15.9687 11.6562 16.3333 12.5416 16.3333 13.5833C16.3333 14.625 15.9687 15.5104 15.2396 16.2395C14.5104 16.9687 13.625 17.3333 12.5833 17.3333ZM0.5 16.9166V10.25H7.16667V16.9166H0.5ZM12.5833 15.6666C13.1667 15.6666 13.6597 15.4652 14.0625 15.0625C14.4653 14.6597 14.6667 14.1666 14.6667 13.5833C14.6667 13 14.4653 12.5069 14.0625 12.1041C13.6597 11.7013 13.1667 11.5 12.5833 11.5C12 11.5 11.5069 11.7013 11.1042 12.1041C10.7014 12.5069 10.5 13 10.5 13.5833C10.5 14.1666 10.7014 14.6597 11.1042 15.0625C11.5069 15.4652 12 15.6666 12.5833 15.6666ZM2.16667 15.25H5.5V11.9166H2.16667V15.25ZM6.375 6.49996H9.625L8 3.87496L6.375 6.49996Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Categories;
